import { Text } from "@kvix/ui";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import { motion, useCycle } from "framer-motion";
import React, { useCallback } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    background: theme.palette.primary.main,
  },
  container: {
    width: "100%",
    height: "100%",
    position: "absolute",
    minWidth: 1085,
    userSelect: "none",
    display: "flex",
    overflow: "hidden",

    [theme.breakpoints.down("sm")]: {
      display: (props: any) => (props.modalOpen ? "none" : "flex"),
    },
  },
  textWrapper: {
    width: (props: any) => `${100 / props.animationSteps}%`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 80,

    [theme.breakpoints.down("sm")]: {
      marginTop: 56,
    },
  },
  text: {
    transform: "rotate(270deg)",
    color: "transparent",
    "-webkit-text-stroke-width": "2px",
    "-webkit-text-stroke-color": theme.palette.common.white,
    fontWeight: 700,
    fontSize: "16em",
    position: "relative",
    letterSpacing: 8,

    "&.highlighted": {
      color: theme.palette.common.white,
    },

    [theme.breakpoints.down("lg")]: {
      fontSize: "14em",
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "12em",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "10em",
    },
  },
}));

export const AnimatedBackground: React.FC<{
  animationSteps: number;
  modalOpen: boolean;
}> = (props) => {
  const classes = useStyles(props);
  const textElements = [...Array(props.animationSteps).keys()];
  const [x, cycleX] = useCycle(...textElements);

  const handleAnimationComplete = useCallback(
    (currIndex: number) => {
      if (currIndex <= textElements.length - 1) {
        cycleX();
      }
    },
    [cycleX, textElements]
  );

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {textElements.map((_, index) => (
          <motion.div
            key={index}
            className={classes.textWrapper}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0, delay: 0.3 * index }}
            onAnimationComplete={() => handleAnimationComplete(index)}
          >
            <Text
              className={classNames(classes.text, {
                highlighted:
                  x - 1 === index || index === textElements.length - 1,
              })}
            >
              KTV
            </Text>
          </motion.div>
        ))}
      </div>

      {props.children}
    </div>
  );
};
